module.exports = __webpack_public_path__ + "static/img/middleLine.afa9d0d6.png";